<template>
    <div
        class="
            currentAddressTipMain
        "
        :style="{
            color: fontColor,
        }"
        @click="goToAddressManager"
    >
        <i
            class="iconfont icon-weizhi addressIcon"
        ></i>
        <div
            class="addressWrapper"
        >
            <div>
                {{
                    (currentAddress.chooseAddress == '点击设置收货地址'
                        ? ''
                        : '送至: ') + currentAddress.chooseAddress
                }}
            </div>
        </div>
        <div
            class="rightArrow"
            :style="{
                'border-color': fontColor,
            }"
        ></div>
    </div>
</template>

<script>
//
import { mapState, mapGetters } from 'vuex'

//
import { getProvinceCode, getCityCode } from '#/utils/address.js'

export default {
    name: 'CurrentAddressTip',

    props: {
        fontColor: {
            type: String,
            default: '#ffffff',
        },
        shopId: {
            type: Number,
        }
    },

    data() {
        return {
            currentAddress: {
                chooseAddress: '点击设置收货地址',
                contact_province_code: null,
                aAddressCity: null,
                contact_city_code: null,
                lng: null,
                lat: null,
            },
        }
    },

    computed: {
        ...mapState({
            userAddress: (state) => state.address.address,
            customerAddress: (state) => state.address.customerAddress,
            defaultAddress: (state) => state.address.defaultAddress,
        }),
    },

    created() {
        //
        this.checkAddress()
    },

    watch: {
        userAddress() {
            // when net env is bad, useraddress and customeraddress data may delay a long time,
            // so we need to check address when they are available
            if (this.currentAddress.chooseAddress == '点击设置收货地址') {
                this.checkAddress()
            }
        },

        customerAddress() {
            // when net env is bad, useraddress and customeraddress data may delay a long time,
            // so we need to check address when they are available
            if (this.currentAddress.chooseAddress == '点击设置收货地址') {
                this.checkAddress()
            }
        },
    },

    methods: {
        /**
         *
         */
        checkAddress() {
            // address has been set, we do not need to set it again
            if (this.defaultAddress) {
                //
                this.currentAddress = this.defaultAddress

                //
                return
            }

            if (!this.customerAddress.addressTopOne) {
                /**
                 * user position not get, we can not set init address
                 */
                if (!this.userAddress) {
                    return
                }

                /**
                 * compute province and city
                 */
                this.currentAddress = {}

                //
                let userCurrentProvince = this.userAddress.addressComponent
                    .province
                this.currentAddress.contact_province_code = getProvinceCode(
                    userCurrentProvince
                )

                //
                if (
                    this.userAddress.addressComponent.city &&
                    this.userAddress.addressComponent.city.length > 0
                ) {
                    this.currentAddress.aAddressCity = this.userAddress.addressComponent.city
                    this.currentAddress.contact_city_code = getCityCode(
                        this.currentAddress.aAddressCity
                    )
                } else {
                    this.currentAddress.aAddressCity = userCurrentProvince
                    this.currentAddress.contact_city_code = this.currentAddress.contact_province_code
                }

                this.currentAddress.chooseAddress = this.userAddress.formattedAddress
                this.currentAddress.lng = this.userAddress.position.lng
                this.currentAddress.lat = this.userAddress.position.lat

                //
                this.$store.commit(
                    'address/setDefaultAddress',
                    this.currentAddress
                )
            } else {
                this.currentAddress.chooseAddress = this.customerAddress.addressTopOne.chooseAddress
                this.currentAddress.contact_province_code = this.customerAddress.addressTopOne.contact_province_code
                this.currentAddress.aAddressCity = this.customerAddress.addressTopOne.aAddressCity
                this.currentAddress.contact_city_code = this.customerAddress.addressTopOne.contact_city_code
                this.currentAddress.lng = this.customerAddress.addressTopOne.lng
                this.currentAddress.lat = this.customerAddress.addressTopOne.lat

                //
                this.$store.commit(
                    'address/setDefaultAddress',
                    this.customerAddress.addressTopOne
                )
            }

            //
            this.$set(this.currentAddress, `time_${Date.now()}`, 'currentDate')
        },

        /**
         *
         */
        goToAddressManager() {
            if(this.shopId)
            {
                this.$router.push({
                    path: `/listAddressManager?shopId=${this.shopId}`,
                })
            }
            else {
                this.$router.push({
                    path: `/listAddressManager`,
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.currentAddressTipMain
{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    font-size: $fontSizeContent;
    line-height: 2em;
}

.addressIcon
{
    flex-shrink: 0;
}

.addressWrapper
{
    white-space: nowrap; 
    overflow-x: scroll; 
    flex-grow: 1;
    margin: 0 $margin;
    font-size: 1em;
    line-height: 2em;
    font-weight: 800;
}

.rightArrow {
    flex-shrink: 0;
    width: 0.8em;
    height: 0.8em;
    border-right: 0.02rem solid;
    border-bottom: 0.02rem solid;
    box-sizing: border-box;
    transform-origin: bottom right;
    transform: translateY(-0.4em) rotate(-45deg);
}
</style>